import styled from "styled-components";
import { Button } from "oui";

export const Question = styled.div`
padding: 10px 20px 10px 20px;
display: block;
gap: 10px;
`

export const TextArea = styled.textarea`
display: flex;
width: calc(100vw - 74px);
padding: 16px 16px 16px 16px;
flex-direction: column;
align-items: flex-start;
gap: 10px;
height: ${(props) => props.style?.height};
border-radius: 8px;
background: var(--surface-surface-3, #F7F7F7);
`

export const TextAreaChar = styled.div`
width: calc(100vw - 40px);
text-align: right;
`

export const ButtonWrap = styled.div`
padding: 10px 20px 10px 20px;
`
